<template>
  <div class="handicapPrice-box" v-if="indexData" :class="[{'gear1-Div' :isFutures}]">
    <ul class="top" v-if="!isFutures">
      <li>委比 <span :style="{color:fontColor(indexData[4], 0)}">
        {{indexData[4]?indexData[4].toFixed(2)+'%':get0Text(indexData[4],2,1)}}</span></li>
      <li>委差 <span :style="{color:fontColor(indexData[5], 0)}">
        {{indexData[5]?indexData[5]:get0Text(indexData[5])|numFormat}}</span></li>
    </ul>
    <ul class="middle">
      <li v-for="(ele, index) in grpList" :key="index">
        <!-- 名称 -->
        <span>{{ele[0]}}</span>
        <!-- 报价 -->
        <span
          :class="[{'bg-red':(bid_1==1&&index==12)||(offer_1==1&&index==15)},{'bg-green':(bid_1==2&&index==12)||(offer_1==2&&index==15)},{'bg-none':(bid_1==0&&index==12)||(offer_1==0&&index==15)}]"
          :style="{color:!isFF?fontColor(ele[1], indexData[8]):fontColor(ele[1], indexData[10])}">{{ele[1]}}
        </span>
        <!-- 数量 -->
        <span>{{ele[2]|numFormat}}</span>
      </li>
    </ul>
    <ul class="bottom">
      <li>外盘 <span :style="{color:indexData[7]?'#ef4342':'#333'}">
        {{indexData[7]?indexData[7]:get0Text(indexData[7])|numFormat}}</span></li>
      <li>内盘 <span :style="{color:indexData[7]?'#2ab447':'#333'}">
        {{indexData[6]?indexData[6]:get0Text(indexData[6])|numFormat}}</span></li>
    </ul>
  </div>
</template>

<script>
import {isHKMHKG, checkFutures, zeroBug, ifTransVolToHand,fontColor, isOneOf} from '../../controller/util.js'
import {TradVolume} from '../../util/index.js'
export default {
  name: 'handicapPrice',
  props: {
    prod_code: {
      type: String,
      default: ''
    },
    throttle: {
      type: Number,
      default: 0
    }
  },
  async created() {
    this.isHKMHKG = isHKMHKG(this.prod_code)
    this.isFutures = checkFutures(this.prod_code)
    if(this.isFutures) {
      this.grpName = ['卖出','买入']
    }
    const a = await this.vueFunction.getToFixed(this.prod_code)
    if (a || a==0) {
      this.priceFixedNum = a
      this.getType(this.prod_code, 'hq_type_code')
    }
  },
  data() {
    return {
      timer: null,
      fields: [
        'offer_grp', // 2委卖档位
        'bid_grp', // 3委买档位
        'entrust_rate', // 4委比
        'entrust_diff', // 5委差
        'business_amount_in', // 6内盘成交量
        'business_amount_out', // 7外盘成交量
        'preclose_px', // 8昨收价
        'last_px', // 9最新价
        'prev_settlement', // 10昨结
        'hq_type_code'
      ],
      indexData: [],
      grpList: [],
      grpName: ['卖五','卖四','卖三','卖二','卖一','买一','买二','买三','买四','买五'],
      entrust_rate: 0,
      entrust_diff: 0,
      bid_grp: 0,
      offer_grp: 0,
      business_amount_in: 0,
      business_amount_out: 0,
      bid_1: 0,
      offer_1: 0,
      isHKMHKG: false,
      isFutures: false,
      priceFixedNum: 2, // 价格类字段保留小数位数
      isFF: false
    }
  },
  methods: {
    // 板块类型
    getType(code, fields) {
      let params = {code, fields}
      this.OpenAPI.real(params).then(res => {
        this.indexData = res[code];
        this.type_code = this.indexData[2]
        // 期权/期货
        let ffList = ['CCFX','XSHO','XSGE','XDCE','XZCE','SHGE']
        this.isFF = isOneOf(ffList, this.type_code)
      }).then(() => {
        this.getIndexDataInterval(this.prod_code, this.fields.join(','))
        // 轮询
        if (this.throttle > 0) {
          this.timer = setInterval(() => {
            this.getIndexDataInterval(this.prod_code, this.fields.join(','))
          }, 10000);
        }
      });
    },
    // 行情数据
    getIndexDataInterval(code, fields) {
      let params = { code, fields };
      this.OpenAPI.real(params).then(res => {
        this.indexData = res[code];
      });
    },
    // 字体颜色
    fontColor(current, compare) {
      return fontColor(current, compare)
    },
    // 当数值为0时根据最新价判断显示什么
    // fixed为小数点位数
    get0Text(curr,fixed,per) {
      let obj = {
        self:curr,
        refer_val:this.indexData[9],
        type:fixed?1:2,
        radioFix:fixed
      }
      let text = zeroBug(obj)
      if(per && text === 0) {
        text = text + '%'
      }
      return text
    }
  },
  computed: {
    handRule() {
      const val = ifTransVolToHand(this.prod_code)
      if(val === true) {
        return this.indexData[1]
      }else if (typeof val === 'number') {
        return val
      }else {
        return 1
      }
    }
  },
  watch: {
    indexData: {
      handler(newVal, oldVal) {
        this.grpList = []
        var arr = []
        var new_offer = this.indexData[2].split(',')
        new_offer.pop()
        var tmpArr = []
        // 卖档数据反向
        const gearNum = this.isFutures ? 0 : 5; //期货一档
        for (let i=gearNum; i>=0; i--) {
          var tmp = new_offer.slice(i*3, (i+1)*3)
          if (tmp) {
            tmp.map(ele => {
              tmpArr.push(ele)
            })
          }
        }
        // 卖档买档合并
        if (this.indexData[3]) {
          arr = tmpArr.concat(this.indexData[3].split(','))
        }
        const gearTotal = this.isFutures ? 2 : 10
        for (let j=0; j<gearTotal; j++) {
          var temp = arr.slice(j*3, (j+1)*3)
          temp.pop()
          temp.unshift(this.grpName[j])
          temp[1] = Number(temp[1])
          temp[2] = Number(temp[2])
          // 买卖报价
          if (temp[1] != 0) {
            temp[1] = temp[1].toFixed(this.priceFixedNum)
          } else {
            temp[1] = '--'
          }
          // 委托量
          if (temp[2] != 0) {
            temp[2] = Math.round(temp[2]/this.handRule)
          } else {
            temp[2] = '--'
          }
          this.grpList.push(temp)
        }
        // 尾差内外盘
        this.indexData[5] = this.indexData[5]/this.handRule
        this.indexData[6] = this.indexData[6]/this.handRule
        this.indexData[7] = this.indexData[7]/this.handRule
        // 背景颜色
        let timeout = 2000
        if (newVal[4] > oldVal[4]) { // 委比
          this.entrust_rate = 1
        } else if (newVal[4] < oldVal[4]) {
          this.entrust_rate = 2
        }
        if (newVal[5] > oldVal[5]) { // 委差
          this.entrust_diff = 1
        } else if (newVal[5] < oldVal[5]) {
          this.entrust_diff = 2
        }
        if (newVal[6] > oldVal[6]) { // 内盘成交量
          this.business_amount_in = 1
        } else if (newVal[6] < oldVal[6]) {
          this.business_amount_in = 2
        }
        if (newVal[7] > oldVal[7]) { // 外盘成交量
          this.business_amount_out = 1
        } else if (newVal[7] < oldVal[7]) {
          this.business_amount_out = 2
        }
        if (newVal[7] > oldVal[7]) { // 卖一
          this.bid_1 = 1
        } else if (newVal[7] < oldVal[7]) {
          this.bid_1 = 2
        }
        if (newVal[7] > oldVal[7]) { // 买一
          this.offer_1 = 1
        } else if (newVal[7] < oldVal[7]) {
          this.offer_1 = 2
        }
        setTimeout(() => {
          this.entrust_rate = 0
          this.entrust_diff = 0
          this.business_amount_in = 0
          this.business_amount_out = 0
          this.bid_1 = 0
          this.offer_1 = 0
        }, timeout);
      },
      inmediate: true,
      deep: true
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style lang='scss' scoped>
  * {
    margin: 0;
    padding: 0;
    list-style-type: none;
    font-size: 14px;
  }
  $box_width: 100%;
  $line_height: 40px;
  $border_color: #399BFF;
  .handicapPrice-box {
    box-sizing: border-box;
    width: $box_width;
    border: 1px solid $border_color;
    ul {
      width: $box_width;
    }
    .top {
      display: flex;
      border-bottom: 1px solid $border_color;
      li {
        width: $box_width/2;
        line-height: $line_height;
        padding: 0 10px;
        &:last-child {
          text-align: right
        }
        span {
          padding: 0 5px;
          border-radius: 3px;
        }
      }
    }
    .middle {
      display: flex;
      flex-wrap: wrap;
      li {
        &:hover {
          background: #E4EDF3;
        }
        width: $box_width;
        line-height: ($line_height)-8;
        display: flex;
        justify-content: center;
        &:nth-child(5n) {
          border-bottom: 1px solid $border_color;
        }
        >span:first-child {
          text-align: left;
          width: 30%;
        }
        >span:last-child {
          width: 35%;
        }
        >span {
          width: 25%;
          padding: 0 10px;
          text-align: right;
          span {
            border-radius: 3px;
          }
        }
      }
    }
    .bottom {
      line-height: $line_height;
      display: flex;
      li {
        width: $box_width/2;
        padding: 0 10px;
        &:last-child {
          text-align: right;
        }
        span {
          border-radius: 3px;
        }
      }
    }
  }
  .blue {
    color: #399BFF;
  }
  .bg-red {
    // background: #F9D9E4;
    background: rgb(255,253,215);
  }
  .bg-green {
    // background: #D3F5D4;
    background: rgb(255,253,215);
  }
  .bg-none {
    background-color: white;
  }
  // 针对买卖只有一档的样式
  .gear1-Div {
    .middle li {
      margin: 3px 0;
    }
    .bottom {
      border-top: 1px solid #399BFF;
    }
  }
</style>
